import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    description: 'Settings > Automation > Order Filters - Name column',
    defaultMessage: 'Name',
    id: 'T2Cqgd',
  },
  description: {
    description: 'Settings > Automation > Order Filters - Description column',
    defaultMessage: 'Description',
    id: 'Se1ZXA',
  },
  lastModified: {
    description: 'Settings > Automation > Order Filters - Last Modified column',
    defaultMessage: 'Last Modified',
    id: 'DxI4s3',
  },
  actions: {
    description: 'Settings > Automation > Order Filters - Actions column',
    defaultMessage: 'Actions',
    id: '4Eac48',
  },
  editFilterLink: {
    description: 'Settings > Automation > Order Filters - Edit Filter Link',
    defaultMessage: 'Edit',
    id: 'FUJjSO',
  },
  deleteFilterLink: {
    description: 'Settings > Automation > Order Filters - Delete Filter Link',
    defaultMessage: 'Delete',
    id: '4ySqCM',
  },
  copyFilterLink: {
    description: 'Settings > Automation > Order Filters - Copy Filter Link',
    defaultMessage: 'Copy',
    id: '5RpSsf',
  },
  copyFilterAppend: {
    description: 'Settings > Automation > Order Filters - copy filter action appending the word copy',
    defaultMessage: '(copy)',
    id: 'irdarX',
  },
});
